// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Huawei {
  .table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin: 25px 0;
    font-size: 0.9em;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }

  .table thead tr {
    background-color: #f2f2f2;
    color: #333333;
    text-align: left;
  }

  .table th,
  .table td {
    padding: 12px 15px;
    border-bottom: 1px solid #e0e0e0;
  }

  .table th {
    position: sticky;
    top: 0;
    background-color: #f2f2f2;
  }

  .table th:not(:last-child) {
    border-right: 1px solid #e0e0e0;
  }

  .table td:not(:last-child) {
    border-right: 1px solid #e0e0e0;
  }

  .table tbody tr:nth-of-type(even) {
    background-color: #fafafa;
  }

  /* Remove left padding in the first cell and right padding in the last cell for a full-width effect */
  .table th:first-child,
  .table td:first-child {
    padding-left: 0;
  }

  .table th:last-child,
  .table td:last-child {
    padding-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Huawei.css"],"names":[],"mappings":"AAAA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,4DAA4D;IAC5D,uCAAuC;EACzC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qGAAqG;EACrG;;IAEE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["#Huawei {\n  .table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    margin: 25px 0;\n    font-size: 0.9em;\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n  }\n\n  .table thead tr {\n    background-color: #f2f2f2;\n    color: #333333;\n    text-align: left;\n  }\n\n  .table th,\n  .table td {\n    padding: 12px 15px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .table th {\n    position: sticky;\n    top: 0;\n    background-color: #f2f2f2;\n  }\n\n  .table th:not(:last-child) {\n    border-right: 1px solid #e0e0e0;\n  }\n\n  .table td:not(:last-child) {\n    border-right: 1px solid #e0e0e0;\n  }\n\n  .table tbody tr:nth-of-type(even) {\n    background-color: #fafafa;\n  }\n\n  /* Remove left padding in the first cell and right padding in the last cell for a full-width effect */\n  .table th:first-child,\n  .table td:first-child {\n    padding-left: 0;\n  }\n\n  .table th:last-child,\n  .table td:last-child {\n    padding-right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
